<template>
  <div
    class="basis-full flex conditions"
    :class="{
      'conditions-row md:basis-1/2 lg:basis-1/3': displayList == 'row',
      'conditions-column': displayList == 'column',
    }"
  >
    <div
      class="border-[#cbcbcb] border-t-[1px] border-collapse flex items-center w-full"
      :class="{
        'md:w-[90%] lg:w-4/5 md:w-max-[346px]': displayList == 'row',
      }"
    >
      <NuxtLinkLocale :locale="switchBlogLocale()"
        class="p-4 flex flex-1 items-center cursor-pointer"
        :to="listType == 'tests' ? testProductUrl(listData) : generateHelpAdviceURL(listData)"
      >
        <span class="text-blog-18 font-semibold"> {{ listData.title }}</span>
        <NuxtImg
          loading="lazy"
          src="/icons/arrow-right-black.svg"
          alt="checkmark"
          class="ml-auto w-2.5 h-2 colorize-blue"
          width="10"
          height="8"
        />
      </NuxtLinkLocale>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  listData: {
    type: Object,
  },
  categorySlug: {
    type: String,
  },
  displayList: {
    type: String,
    default: "column",
  },
  listType: {
    type: String,
    default: "conditions",
  },
  total: {
    type: Number,
  },
});

const testProductUrl = (item) => {
  return `/tests/${
    item.primary_category ? item.primary_category.slug + "/" : ""
  }${item.slug}`;
};

</script>
<style scoped>
.conditions-row:nth-child(odd) {
  @apply md:justify-start;
}
.conditions-row:nth-child(even) {
  @apply md:justify-end;
}
.conditions-row:nth-child(3n + 1) {
  @apply lg:justify-start;
}
.conditions-row:nth-child(3n + 2) {
  @apply lg:justify-center;
}
.conditions-row:nth-child(3n) {
  @apply lg:justify-end;
}
.conditions-row:nth-last-child(-n + 3) > div {
  @apply lg:border-b-[1px];
}
.conditions-row:nth-last-child(-n + 2) > div {
  @apply md:border-b-[1px];
}
.conditions:last-child > div {
  @apply last:border-b-[1px];
}
</style>
